const checkLabelDesktopInput = label =>
  label
    ? { height: '56px', paddingTop: '18px', paddingBottom: '10px' }
    : { height: '56px' }
const setLargeDesktopInput = (value, label) =>
  value
    ? checkLabelDesktopInput(label)
    : { height: '56px', paddingTop: '14px', paddingBottom: '14px' }

const checkLabelMobileInput = label =>
  label
    ? { height: '46px', paddingTop: '18px', paddingBottom: '10px' }
    : { height: '46px' }

const setLargeMobileInput = (value, label) =>
  value
    ? checkLabelMobileInput(label)
    : { height: '46px', paddingTop: '14px', paddingBottom: '14px' }
const typeAheadInputStyle = (value, label, isMobile) => {
  return isMobile
    ? setLargeMobileInput(value, label)
    : setLargeDesktopInput(value, label)
}

export default typeAheadInputStyle
